import { render, staticRenderFns } from "./CadastroTetoAtendimento.vue?vue&type=template&id=3e3c6f5e&"
import script from "./CadastroTetoAtendimento.vue?vue&type=script&lang=js&"
export * from "./CadastroTetoAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports